import { render } from "./UploaderAttachment.vue?vue&type=template&id=51919336"
import script from "./UploaderAttachment.vue?vue&type=script&lang=js"
export * from "./UploaderAttachment.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/components/views/producer/production/delivery_container/uploader_attachment.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fproducer%2Fproduction%2Fdelivery_container%2FUploaderAttachment.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/container.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fproducer%2Fproduction%2Fdelivery_container%2FUploaderAttachment.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__